import { render, staticRenderFns } from "./CruiseReviewItem.vue?vue&type=template&id=ef49e45e&scoped=true"
import script from "./CruiseReviewItem.vue?vue&type=script&lang=js"
export * from "./CruiseReviewItem.vue?vue&type=script&lang=js"
import style0 from "./CruiseReviewItem.vue?vue&type=style&index=0&id=ef49e45e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef49e45e",
  null
  
)

export default component.exports